import React from "react";
import { connect } from "react-redux";
import {
    changeLang,
    changeTheme,
    openModalDialog,
    closeModalDialog,
    setEditMode,
    setViewMode
} from "../../redux/actions/report-actions.js";

import { theme_dark, theme_light } from "../../commonConstants";
import {
    paramTable_dialog,
    graphIntervals_dialog,
    medicalReport_dialog,
    chooseCmpx_dialog,
    wait_dialog,
    measurer_dialog,
    aim_dialog
} from "../popup-dialog-manager/constants";

import "./debug-panel.scss";

class DebugPanel extends React.Component {
    state = {
        hide: false
    };
    onLangChange = lang => {
        this.props.changeLang(lang);
    };

    onCloseModal = () => {
        this.props.closeModalDialog();
    };

    onOpenModal = _win => {
        this.props.openModalDialog(_win);
    };

    onThemeChange = theme => {
        this.props.changeTheme(theme);
    };

    render() {
        const { setEditMode, setViewMode } = this.props;
        return this.state.hide ? null : (
            <div className="debug-panel">
                <div className="ctr-container">
                    <button onClick={() => this.setState({ hide: true })}>Close</button>
                    <div className="item">
                        <button onClick={() => this.onLangChange("RU")}>RU</button>/
                        <button onClick={() => this.onLangChange("EN")}>EN</button>
                    </div>

                    <div className="item">
                        <button onClick={() => this.onThemeChange(theme_light)}>Light</button>/
                        <button onClick={() => this.onThemeChange(theme_dark)}>Dark</button>
                    </div>

                    <div className="item">
                        <button onClick={setEditMode}>EDIT</button>/<button onClick={setViewMode}>VIEW</button>
                    </div>
                </div>
                <div className="ctr-container ">
                    <div className="title">Модальные окна</div>
                    <button onClick={() => this.onOpenModal(paramTable_dialog)}>Табл.</button>
                    <button onClick={() => this.onOpenModal(graphIntervals_dialog)}>Граф. инт.</button>
                    <button onClick={() => this.onOpenModal(medicalReport_dialog)}>Мед.закл.</button>
                    <button onClick={() => this.onOpenModal(chooseCmpx_dialog)}>Whole graph</button>
                    <button onClick={() => this.onOpenModal(wait_dialog)}>Wait</button>
                    <button onClick={() => this.onOpenModal(measurer_dialog)}>Measurer</button>
                    <button onClick={() => this.onOpenModal(aim_dialog)}>Цель направлен</button>
                    <button onClick={() => this.onCloseModal()}>X</button>
                </div>
            </div>
        );
    }
}
const mapStateToProps = () => {
    return {};
};
const mapDispatchToProps = {
    changeLang,
    changeTheme,
    openModalDialog,
    closeModalDialog,
    setEditMode,
    setViewMode
};

export default connect(mapStateToProps, mapDispatchToProps)(DebugPanel);
